const ACTIVE_CLIENT_STATUS = "active-string";

export const DEFAULT_PENDING_WEEK_WORKOUTS = Object.freeze([
  false,
  false,
  false,
  false,
  false,
  false,
  false,
]);

const normalizeString = (value) =>
  typeof value === "string" ? value.trim() : "";

export const normalizePendingWorkspaceIsChecked = (value) => value === true;

export const normalizePendingWorkspaceWeekWorkouts = (value) => {
  if (!Array.isArray(value)) {
    return [...DEFAULT_PENDING_WEEK_WORKOUTS];
  }

  const normalized = value.slice(0, 7).map((day) => day === true);
  while (normalized.length < 7) {
    normalized.push(false);
  }
  return normalized;
};

export const isWorkablePendingWorkspaceClient = (client) => {
  if (!client || typeof client !== "object") {
    return false;
  }

  if (normalizeString(client?.status) === ACTIVE_CLIENT_STATUS) {
    return false;
  }

  if (client?.usePendingBlocksPath !== true) {
    return false;
  }

  return normalizeString(client?.pendingUserId) !== "";
};

export const buildPendingWorkspaceStatePatch = ({
  client,
  isChecked,
  weekWorkouts,
  lastUpdate,
} = {}) => {
  const patch = {
    coach_id: normalizeString(client?.coach?.id),
    pending_user_id: normalizeString(client?.pendingUserId),
    invitation_id: normalizeString(client?.invitationId),
    invitation_email:
      normalizeString(client?.invitationEmail) || normalizeString(client?.email),
  };

  if (lastUpdate !== undefined) {
    patch.last_update = lastUpdate;
  }

  if (isChecked !== undefined) {
    patch.is_checked = normalizePendingWorkspaceIsChecked(isChecked);
  }

  if (weekWorkouts !== undefined) {
    patch.week_workouts = normalizePendingWorkspaceWeekWorkouts(weekWorkouts);
  }

  return patch;
};

export const resolvePendingWorkspaceState = (workspaceData) => ({
  isChecked: normalizePendingWorkspaceIsChecked(workspaceData?.is_checked),
  weekWorkouts: normalizePendingWorkspaceWeekWorkouts(
    workspaceData?.week_workouts
  ),
});
